import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';

import {
  API_bulk_update_custom_field_settings,
  API_create_update_custom_field_layout,
  API_delete_custom_field,
  API_get_custom_fields_layout_path,
} from './custom-fields-paths';
import { TLayoutConfig } from 'react-lib/components/organisms/CustomFieldGroupsSettings';
import { ECustomFieldBulkAction } from 'src/app/project/modules/custom-fields/custom-field-bulk-action.enum';

export interface CustomFieldsLayoutResponse {
  fieldsLayout: TLayoutConfig[];
}

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsLayoutApiProviderService {
  constructor(private apiService: ApiService) {}

  getAllCustomFieldsLayout(workspaceId: string): Observable<CustomFieldsLayoutResponse> {
    const url = API_get_custom_fields_layout_path(workspaceId);

    return this.apiService.get<CustomFieldsLayoutResponse>(url);
  }

  createUpdateCustomFieldsLayout({
    workspaceId,
    body,
  }: {
    workspaceId: string;
    body: CustomFieldsLayoutResponse;
  }): Observable<CustomFieldsLayoutResponse> {
    const url = API_create_update_custom_field_layout(workspaceId);

    return this.apiService.put<CustomFieldsLayoutResponse>(url, body);
  }

  deleteCustomField({
    workspaceId,
    customFieldId,
  }: {
    workspaceId: string;
    customFieldId: string;
  }) {
    const url = API_delete_custom_field({ workspaceId, customFieldId });

    return this.apiService.delete(url);
  }

  bulkUpdateCustomFieldSettings(
    workspaceId: string,
    body: { templateIds: string[]; action: ECustomFieldBulkAction },
  ): Observable<void> {
    const url = API_bulk_update_custom_field_settings(workspaceId);

    return this.apiService.put<void>(url, body);
  }
}
